import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type CtaButtonProps = {
  children: React.ReactNode;
  href?: string;
  className?: string;
  size?: 'lg' | 'sm';
  variant?: 'ink' | 'gold';
};
export function CtaButton({
  children,
  href = '#pricing',
  className = '',
  size = 'lg',
  variant = 'ink'
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-9 py-4 text-sm sm:text-base rounded-full' : 'px-6 py-3 text-xs sm:text-sm rounded-full';
  const palette = variant === 'gold' ? 'bg-gold-dark hover:bg-ink text-white focus-visible:ring-gold/40' : 'bg-ink hover:bg-gold-dark text-ivory focus-visible:ring-gold/40';
  return <a href={href} className={`group inline-flex items-center justify-center gap-2.5 font-semibold uppercase tracking-[0.14em] shadow-card hover:shadow-lift transition-all duration-300 hover:-translate-y-0.5 focus:outline-none focus-visible:ring-4 ${palette} ${sizing} ${className}`} data-id="element-97" data-mp="10c7r6aekrrrk">
      {children}
      <ArrowRightIcon className="w-4 h-4 transition-transform group-hover:translate-x-1" aria-hidden="true" data-id="element-98" data-mp="35xfo76wcd5aa" />
    </a>;
}